import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  isLoyaltyAccordionOpen: true,
  minimumLoyaltyAmount: '5',
  minimumLoyaltyPoints: 500,
  showLoyaltyPaymentAsAccordion: false,
} satisfies CheckoutConfig['paymentLoyalty']
